<p class="text-md my-4 text-black-7 text-center">
  {{ "common.scan.qr.code" | translate }}
</p>
<div class="flex justify-center">
  <img [src]="environment.imagePath + '/home-page/platform/qr-code.svg'" alt="QR Code" />
</div>
